export default function capitalize(string: any) {
  return `${string.charAt(0).toUpperCase()}${string.slice(1)}`;
}
